// see: https://gist.github.com/nuxodin/73a2c2423cbbf6818c28ad803985d5c7
/* Copyright (c) 2016 Tobias Buschor https://goo.gl/gl0mbf | MIT License https://goo.gl/HgajeK */

if (!HTMLFormElement.prototype.reportValidity) {
  HTMLFormElement.prototype.reportValidity = function() {
    if (this.checkValidity()) return true
    const btn = document.createElement('button')
    this.appendChild(btn)
    btn.click()
    this.removeChild(btn)
    return false
  }
}
